module.exports = __webpack_public_path__ + "img/logo.8669d1bc.svg";